export default {
    setCommissions(state,payload){
        state.commissions = payload;
    }
}